var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconTime"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.8 8C1.8 4.57679 4.57187 1.8 7.993 1.8C11.4227 1.8 14.2 4.57835 14.2 8C14.2 11.4217 11.4227 14.2 7.993 14.2C4.57187 14.2 1.8 11.4232 1.8 8Z",
    stroke: "#121922",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4.8C7 4.63431 7.13431 4.5 7.3 4.5H8.2C8.36569 4.5 8.5 4.63431 8.5 4.8V7.50821C8.5 7.59724 8.53955 7.68167 8.60794 7.73867L10.9997 9.73178C11.127 9.83785 11.1442 10.027 11.0381 10.1543L10.4619 10.8457C10.3558 10.973 10.1667 10.9902 10.0394 10.8841L7.35982 8.65113C7.13182 8.46113 7 8.17969 7 7.88291V4.8Z",
    fill: "#121922"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/iconTime.dabc148e667bbd6d826bd779e3a377ea.svg";
export { ForwardRef as ReactComponent };